var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-loader"},[_c('span',{staticClass:"el-icon-loading"}),_vm._v(" "+_vm._s(_vm.$t('layers-loading'))+"... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }